'use client';

import classNames from 'classnames';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { FC, useEffect, useState } from 'react';

import { EventDetailsType } from '@/api/config/types';
import Image from '@/components/core/Image';
import MeetingBook from '@/components/popups/MeetingBook';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

export interface EventProps {
  event: EventDetailsType;
  isColumn?: boolean;
  lang?: string;
}

const Event: FC<EventProps> = ({ event, isColumn, lang }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeBooking, setActiveBooking] = useState<EventDetailsType>();
  const { t } = useTranslation();
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const eventId = searchParams.get('eventId');
    if (eventId && eventId == event.id) {
      setActiveBooking(event);
      setShowModal(true);
    } else {
      setActiveBooking(undefined);
    }
  }, []);

  const modalController = (booking?: EventDetailsType) => {
    if (booking) {
      setShowModal(() => {
        router.push(`${pathname}?eventId=${event.id}`, {
          scroll: false,
        });
        return true;
      });
      setActiveBooking(booking);
    } else {
      setShowModal(() => {
        router.push(pathname, {
          scroll: false,
        });
        return false;
      });
      setActiveBooking(undefined);
    }
  };
  //  href={`${UPCOMING_EVENTS.getPath((lang as string) || 'en')}/${event.id}`}
  return (
    <>
      <div className={classNames('eventTemplateRow', { inSlider: !isColumn })}>
        <div className="rowInnerLeft" style={{ backgroundColor: event.bgColor }}>
          <div className="mainRowImgHolder mainRowImgHolderMedium">
            {event.logo && (
              <Image alt="event" width={450} height={450} src={event.logo} className="mainRowImg" />
            )}
          </div>
        </div>
        <div className="rowInnerMiddle">
          <div className="rowInnerMiddleTop">
            <span className="rowMiddleTitle">{event.title}</span>
            <div
              className="rowMiddleTxt"
              dangerouslySetInnerHTML={{ __html: event.standNumber }}
            />
          </div>
          <div className="rowInnerMiddleBottom">
            <div className="languageOption" key={event.logo}>
              <Image width={36} height={24} src={event.countryLogo} alt="certificate-flag" />
            </div>
            <span className="rowMiddleBottomTxt">{event.country}</span>
          </div>
        </div>
        <div className="rowInnerRight">
          <span className="rowRightTxt">{event.eventDate}</span>
          <button
            className="button btnTypeBig btnTypeOrange"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              modalController(event);
            }}
          >
            <p>{t('Homepage-Button-Bookameeting')}</p>
          </button>
        </div>
      </div>

      {activeBooking && (
        <MeetingBook
          key={activeBooking.id}
          modalState={showModal}
          meeting={activeBooking!}
          onControll={modalController}
        />
      )}
    </>
  );
};

export default Event;
